/**
 * Peer-reviewed studies that validate XION technology.
 * PDFs are served from /public/studies/. DOIs link to the publisher of record.
 */

export const clinicalStudies = [
  {
    id: 'caffier-2018',
    topic: '3D Laryngostroboscopy',
    title:
      'Development of Three-Dimensional Laryngostroboscopy for Office-Based Laryngeal Diagnostics and Phonosurgical Therapy',
    authors: 'Caffier PP, Nawka T, Ibrahim-Nasr A, Thomas B, Müller H, Ko S-R, Song W, Gross M, Weikert S',
    journal: 'The Laryngoscope',
    year: 2018,
    doi: '10.1002/lary.27260',
    doiUrl: 'https://doi.org/10.1002/lary.27260',
    pdf: '/studies/caffier-2018-3d-laryngostroboscopy.pdf',
    tags: ['3D Stroboscopy', 'Phoniatrics', 'EndoSTROBE'],
    summary:
      'The first development and clinical evaluation of three-dimensional (3D) laryngostroboscopy for office-based laryngeal diagnostics and phonosurgery. The 3D system was compared with conventional 2D stroboscopy for visualising the larynx and vocal-fold vibration.',
    findings: [
      'Stereoscopic 3D added genuine depth perception and spatial representation of the larynx and vocal folds.',
      'Improved assessment of factors that influence phonosurgical success and more precise surgical planning.',
      'Enabled advanced office-based laryngeal diagnostics and therapy.',
    ],
    xionRelevance:
      'Documents the world-first 3D laryngostroboscopy that is the centrepiece of the EndoSTROBE Spectar phoniatrics workstation.',
    relatedLink: { label: 'EndoSTROBE Spectar', to: '/system-solutions/endostrobe-spectar' },
  },
  {
    id: 'niessen-2025',
    topic: 'PIET vs NBI in FEES',
    title:
      'Comparison of filter-based and software-based image enhancement systems for endoscopic swallowing diagnostics: a head-to-head study',
    authors: 'Niessen AC, Glinzer J, Zang J, Pflug C',
    journal: 'European Archives of Oto-Rhino-Laryngology',
    year: 2025,
    doi: '10.1007/s00405-025-09413-w',
    doiUrl: 'https://doi.org/10.1007/s00405-025-09413-w',
    pdf: '/studies/niessen-2025-piet-vs-nbi-swallowing.pdf',
    tags: ['PIET', 'FEES', 'Image Enhancement', 'Dysphagia'],
    summary:
      'An independent, head-to-head comparison of XION\u2019s software-based PIET against hardware filter-based Narrow Band Imaging (NBI) for enhancing the visibility of food dyes during Flexible Endoscopic Evaluation of Swallowing (FEES).',
    findings: [
      'Both PIET and NBI improved dye visibility by roughly tenfold.',
      'PIET was preferred for red and purple dyes; NBI for yellow, green and orange.',
      'For blue, black and white \u2014 where neither added much \u2014 PIET was almost universally preferred.',
    ],
    xionRelevance:
      'Confirms XION PIET delivers image enhancement on par with dedicated NBI hardware for swallowing diagnostics \u2014 in software, across HD/4K and 2D/3D.',
    relatedLink: { label: 'PIET Technology', to: '/technology/piet' },
  },
  {
    id: 'saleh-2022',
    topic: '3D Video-Endoscopic Dissection',
    title: 'The inside-out surgical anatomy of the paraglottic space: a video-guided endoscopic dissection',
    authors: 'Saleh HMA, Seidel N, Jöns T, Mürbe D, Nawka T',
    journal: 'Laryngoscope Investigative Otolaryngology',
    year: 2022,
    doi: '10.1002/lio2.979',
    doiUrl: 'https://doi.org/10.1002/lio2.979',
    pdf: '/studies/saleh-2022-paraglottic-space.pdf',
    tags: ['3D Video-Endoscopy', 'Surgical Anatomy', 'Education'],
    summary:
      'A video-guided, inside-out endoscopic dissection of the paraglottic space \u2014 an area critical to laryngeal cancer spread and surgical planning \u2014 performed on frozen cadavers using a XION 3D video laryngoscope.',
    findings: [
      'Defined the paraglottic space as a distinct compartment of muscle, fat and neurovascular structures, with described boundaries.',
      '3D endoscopy gave a realistic sense of depth and a wide, close-proximity field of view.',
      'Video documentation supports teaching and review of complex laryngeal surgical anatomy.',
    ],
    xionRelevance:
      'Demonstrates the XION 3D video laryngoscope as a research- and education-grade tool for surgical anatomy and training.',
    relatedLink: { label: 'XION 3D Endoscope', to: '/products/rigid-endoscopes/xion-3d-endoscope' },
  },
];

export default clinicalStudies;
